// Copyright (c) 2019 Deere & Company

import Customer from '@deere/cps-it.warranty-model-factory/lib/customer';
import actions from '../../action-list';
import {getDefaultState} from '../state';

const setCustomer = (state, action) =>
    Customer.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().customer, action) => {

    const actionTypes = {
        [actions.SET_CLAIM_INCENTIVE_CUSTOMER_DETAILS]: setCustomer
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/incentive/reducers/customer.js